import React from "react";
import { useDispatch } from "react-redux";
import { removePretextsStart } from "../../../../../redux/chats/chats.actions";
import useTranslation from "hooks/useTranslation";

const RemovePretext = ({ deletingPretext, setPretextsContent }) => {
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation("COMMON");
  const { t } = getTranslation();

  const handleRemovePRetext = () => {
    const formData = {
      id: deletingPretext.id,
      publicId: deletingPretext.publicId,
      delete: true,
    };

    dispatch(removePretextsStart(formData));
  };

  return (
    <div>
      <p className="delete_msg_alert_text">
        {t("MODAL").DELETE_SHORTCUT_MSG_CONFIRM}
      </p>
      <div className="flex flex-jc-e remove__pretext__body_footer_actions">
        <button
          onClick={() => setPretextsContent("pretexts")}
          className="remove__pretext__body_footer_actions_dissuasion_btn btn btn-tertiary"
        >
          {t("MODAL").CANCEL}
        </button>
        <button
          onClick={() => handleRemovePRetext()}
          className="remove__pretext__body_footer_actions_save_btn btn btn-primary"
        >
          {t("MODAL").CONFIRM}
        </button>
      </div>
    </div>
  );
};

export default RemovePretext;
